import Vue from 'vue'
import { HTTP } from '../../../../utils/httpCommonUtil'
// import 'vue-loaders/dist/vue-loaders.css';
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';

export default Vue.component('expiry-cert-notice-email-card', {
  name: 'ExpiryCertNoticeEmailCard',
  data () {
    return {
      cardExpanded: false,
      notificationEmailErrorMessage: '',
      loadingInitialData: false,
      updatingEmail: false,
      notificationEmail: '',
      initialNotificationEmail: ''
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner
  },
  created: function () {
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getExpiringCertificationsNotificationEmail()
      }
    },
    getExpiringCertificationsNotificationEmail () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/settings/expiring-certification-notification-email')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data || !response.data.data.certificationsExpiringNotificationEmail) { 
          throw new Error("Error retrieving email.");          
        }
        self.notificationEmail = response.data.data.certificationsExpiringNotificationEmail;
        self.initialNotificationEmail = self.notificationEmail;
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Retrieving Username',
          text: 'An error occurred retrieving the Certifications Expiring Notification Email.'
        });
      })
    },
    cancel () {
      this.notificationEmail = this.initialNotificationEmail;
    }, 
    updateEmail (notificationEmail: string) {
      let self = this
      self.notificationEmailErrorMessage = ''
      let loadingButtonTimeout = setTimeout(function () {
        self.updatingEmail = true;
      },300);
      HTTP.put('/api/settings/expiring-certification-notification-email', {
        "newExpiringCertificationNotificationEmail": notificationEmail
      })
      .then(function (response) {
        clearTimeout(loadingButtonTimeout);
        self.updatingEmail = false;
        if (response.data.success) {
          self.initialNotificationEmail = self.notificationEmail;
          self.$notify({
            group: 'main',
            type: 'success',
            title: 'Success',
            text: 'Successfully updated the Certifications Expiring Notification Email Address.'
          });
        } else {
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Editing Email Address',
            text: 'An error occurred updating email address.'
          });
        }
      })
      .catch(function (error) {
        clearTimeout(loadingButtonTimeout);
        self.updatingEmail = false;
      
        self.notificationEmailErrorMessage = getRestParamErrorMessage(error, 'newExpiringCertificationNotificationEmail')
        if (!self.notificationEmailErrorMessage.length) {            
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Editing Email Address',
            text: generalError ? generalError : 'An error occurred updating the email address.',
            // duration: 5000
          });
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/settings/cards/expiryCertNoticeEmail/ExpiryCertNoticeEmailCard.ts